"use client"

import type React from "react"

interface SwitchProps {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  label?: string
  size?: "sm" | "md" | "lg"
}

export const Switch: React.FC<SwitchProps> = ({ checked, onChange, disabled = false, label, size = "md" }) => {
  const sizeClasses = {
    sm: "h-4 w-7",
    md: "h-5 w-9",
    lg: "h-6 w-11",
  }

  const thumbSizeClasses = {
    sm: "h-3 w-3",
    md: "h-4 w-4",
    lg: "h-5 w-5",
  }

  const translateClasses = {
    sm: checked ? "translate-x-3" : "translate-x-0",
    md: checked ? "translate-x-4" : "translate-x-0",
    lg: checked ? "translate-x-5" : "translate-x-0",
  }

  return (
    <div className="flex items-center">
      <button
        type="button"
        className={`${sizeClasses[size]} relative inline-flex flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
          disabled
            ? "opacity-50 cursor-not-allowed bg-gray-200 dark:bg-gray-700"
            : checked
              ? "bg-blue-600 dark:bg-blue-500"
              : "bg-gray-200 dark:bg-gray-700"
        }`}
        role="switch"
        aria-checked={checked}
        aria-disabled={disabled}
        onClick={() => !disabled && onChange(!checked)}
      >
        <span
          aria-hidden="true"
          className={`${thumbSizeClasses[size]} ${translateClasses[size]} pointer-events-none inline-block rounded-full bg-white shadow transform ring-0 transition duration-200 ease-in-out`}
        />
      </button>
      {label && (
        <span
          className={`ml-3 text-sm ${disabled ? "text-gray-400 dark:text-gray-500" : "text-gray-900 dark:text-white"}`}
        >
          {label}
        </span>
      )}
    </div>
  )
}
